"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cssAnchorName: true
};
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _TopicClosed = _interopRequireDefault(require("@insided/deprecated-preact-components/topic-list-view/TopicClosed"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _HubAI = require("@insided/shared/modules/HubAI");

var _Replies = _interopRequireDefault(require("../V2/Replies"));

var _Topic = _interopRequireDefault(require("../V2/Topic"));

var _Editor = require("@insided/shared/modules/Content/ThreadedReplies/Editor");

var _ThreadedRepliesWrapper = _interopRequireDefault(require("@insided/shared/modules/Content/ThreadedReplies/ThreadedRepliesWrapper"));

var _Topic2 = _interopRequireDefault(require("../Topic"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PinnedAndBestAnswerSection = _interopRequireDefault(require("./PinnedAndBestAnswerSection"));

var _Post = require("../Post");

Object.keys(_Post).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Post[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Post[key];
    }
  });
});

var _utils = require("../utils");

Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicPage = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicPage, _Component);

  var _super = _createSuper(TopicPage);

  function TopicPage(props) {
    var _this$props$bestAnswe, _this$props$bestAnswe2, _this$props$pinnedRep, _this$props$pinnedRep2;

    var _this;

    (0, _classCallCheck2.default)(this, TopicPage);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inlineEditorWrapperRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "inlineEditorIntersectionObserver", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isEditorOpen: false,
      isStickyEditorOpen: false,
      inlineEditorInView: true,
      inlineEditorScrolledPast: false,
      stickyHasDraft: false,
      stickyFocusWithin: false,
      inlineHasDraft: false,
      inlineFocusWithin: false,
      initialContent: {
        title: _this.props.topic.title,
        topicContent: _this.props.topic.content,
        bestAnswerText: (_this$props$bestAnswe = (_this$props$bestAnswe2 = _this.props.bestAnswer) === null || _this$props$bestAnswe2 === void 0 ? void 0 : _this$props$bestAnswe2.content) !== null && _this$props$bestAnswe !== void 0 ? _this$props$bestAnswe : null,
        pinnedReplyText: (_this$props$pinnedRep = (_this$props$pinnedRep2 = _this.props.pinnedReply) === null || _this$props$pinnedRep2 === void 0 ? void 0 : _this$props$pinnedRep2.content) !== null && _this$props$pinnedRep !== void 0 ? _this$props$pinnedRep : null,
        replies: _this.props.showThreadedReplies ? _this.props.repliesProps.replies.result : _this.props.repliesProps.replies.map(function (reply) {
          return reply.content;
        })
      }
    });
    _this.handleEditorFocus = _this.handleEditorFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEditorCancel = _this.handleEditorCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRepliesUpdated = _this.handleRepliesUpdated.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TopicPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setupInlineEditorIntersectionObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.teardownInlineEditorIntersectionObserver();
    }
  }, {
    key: "getHasTopicReplies",
    value: function getHasTopicReplies() {
      var _this$props = this.props,
          _this$props$showThrea = _this$props.showThreadedReplies,
          showThreadedReplies = _this$props$showThrea === void 0 ? false : _this$props$showThrea,
          repliesProps = _this$props.repliesProps;
      var replies = repliesProps.replies;
      return showThreadedReplies ? replies.result.length > 0 : replies.length > 0;
    }
  }, {
    key: "isThreadedStickyComposerActive",
    value: function isThreadedStickyComposerActive() {
      return this.props.showThreadedReplies === true && this.getHasTopicReplies();
    }
    /** Sticky duplicate when user has scrolled past the inline composer (it sits above the viewport), or while sticky has focus / draft / open. */

  }, {
    key: "showStickyComposerForState",
    value: function showStickyComposerForState(s) {
      if (!this.isThreadedStickyComposerActive()) return false;
      return s.inlineEditorScrolledPast || s.stickyHasDraft || s.stickyFocusWithin || s.isStickyEditorOpen;
    }
  }, {
    key: "teardownInlineEditorIntersectionObserver",
    value: function teardownInlineEditorIntersectionObserver() {
      var _this$inlineEditorInt;

      (_this$inlineEditorInt = this.inlineEditorIntersectionObserver) === null || _this$inlineEditorInt === void 0 ? void 0 : _this$inlineEditorInt.disconnect();
      this.inlineEditorIntersectionObserver = null;
    }
  }, {
    key: "setupInlineEditorIntersectionObserver",
    value: function setupInlineEditorIntersectionObserver() {
      var _this2 = this;

      if (!this.isThreadedStickyComposerActive() || typeof IntersectionObserver === 'undefined') return;
      var el = this.inlineEditorWrapperRef.current;
      if (!el) return;
      this.teardownInlineEditorIntersectionObserver();
      this.inlineEditorIntersectionObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        var inView = entry.isIntersecting;
        var rect = entry.boundingClientRect;
        var scrolledPast = !inView && rect.bottom <= 0;

        _this2.setState(function (prev) {
          var keepStickyWhileInlineVisible = prev.stickyHasDraft || prev.stickyFocusWithin || prev.isStickyEditorOpen;
          var shouldClearStickyOnScrollToInline = inView && !prev.inlineEditorInView && !keepStickyWhileInlineVisible;
          var keepInlineExpandedWhileScrolledAway = prev.inlineFocusWithin && prev.inlineHasDraft;
          var shouldCollapseInlineOnScrollAway = !inView && prev.inlineEditorInView && !keepInlineExpandedWhileScrolledAway;
          return {
            inlineEditorInView: inView,
            inlineEditorScrolledPast: inView ? false : scrolledPast,
            isEditorOpen: shouldCollapseInlineOnScrollAway && !prev.inlineHasDraft ? false : prev.isEditorOpen,
            isStickyEditorOpen: shouldClearStickyOnScrollToInline ? false : prev.isStickyEditorOpen,
            stickyHasDraft: shouldClearStickyOnScrollToInline ? false : prev.stickyHasDraft,
            stickyFocusWithin: shouldClearStickyOnScrollToInline ? false : prev.stickyFocusWithin
          };
        });
      }, {
        root: null,
        threshold: 0,
        rootMargin: '0px'
      });
      this.inlineEditorIntersectionObserver.observe(el);
    }
  }, {
    key: "handleEditorFocus",
    value: function handleEditorFocus() {
      var _this$props2 = this.props,
          currentUser = _this$props2.currentUser,
          _this$props2$showThre = _this$props2.showThreadedReplies,
          showThreadedReplies = _this$props2$showThre === void 0 ? false : _this$props2$showThre;
      var isGuest = !currentUser.id;

      if (isGuest) {
        window.dispatchEvent(new CustomEvent('GuestUserAction'));
      } else {
        this.setState({
          isEditorOpen: true
        }, function () {
          if (!showThreadedReplies) {
            var editorElement = document.getElementById('reply-editor');

            if (editorElement) {
              editorElement.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
              });
            }
          }
        });
      }
    }
  }, {
    key: "handleStickyEditorFocus",
    value: function handleStickyEditorFocus() {
      var currentUser = this.props.currentUser;

      if (!currentUser.id) {
        window.dispatchEvent(new CustomEvent('GuestUserAction'));
        return;
      }

      this.setState({
        isStickyEditorOpen: true
      });
    }
  }, {
    key: "handleEditorCancel",
    value: function handleEditorCancel() {
      this.setState({
        isEditorOpen: false
      });
    }
  }, {
    key: "handleStickyEditorCancel",
    value: function handleStickyEditorCancel() {
      this.setState({
        isStickyEditorOpen: false
      });
    }
  }, {
    key: "handleRepliesUpdated",
    value: function handleRepliesUpdated(replies) {
      this.setState(function (prevState) {
        return {
          initialContent: _objectSpread(_objectSpread({}, prevState.initialContent), {}, {
            replies: replies
          })
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$phrases$F,
          _this$props$phrases,
          _this$props$phrases$F2,
          _this3 = this;

      var _this$props3 = this.props,
          topic = _this$props3.topic,
          currentPage = _this$props3.currentPage,
          attachmentCdn = _this$props3.attachmentCdn,
          authors = _this$props3.authors,
          unlimitedEditPermission = _this$props3.unlimitedEditPermission,
          _this$props3$language = _this$props3.languageList,
          languageList = _this$props3$language === void 0 ? [] : _this$props3$language,
          contentHelpfulnessData = _this$props3.contentHelpfulnessData,
          currentUser = _this$props3.currentUser,
          disableFileAttachments = _this$props3.disableFileAttachments,
          topicContent = _this$props3.topicContent,
          repliesProps = _this$props3.repliesProps,
          pinnedReply = _this$props3.pinnedReply,
          userHasPermissionToReply = _this$props3.userHasPermissionToReply,
          showPostActions = _this$props3.showPostActions,
          bestAnswer = _this$props3.bestAnswer,
          userSubscribed = _this$props3.userSubscribed,
          _this$props3$showThre = _this$props3.showThreadedReplies,
          showThreadedReplies = _this$props3$showThre === void 0 ? false : _this$props3$showThre;
      var _this$state = this.state,
          isEditorOpen = _this$state.isEditorOpen,
          isStickyEditorOpen = _this$state.isStickyEditorOpen,
          initialContent = _this$state.initialContent;
      var replies = repliesProps.replies,
          totalReplies = repliesProps.totalReplies,
          currentSort = repliesProps.currentSort,
          canMarkBestAnswer = repliesProps.canMarkBestAnswer;
      var isGuest = !currentUser.id;
      var isTopicClosedForReply = topic.closed;
      var hasTopicReplies = this.getHasTopicReplies();
      var shouldDisplayReplies = !isTopicClosedForReply || hasTopicReplies;
      var showHasNoPermission = !isTopicClosedForReply && !isGuest && !userHasPermissionToReply;
      var hasReplies = totalReplies > 0;
      var showFirstToReplyBanner = !hasReplies && !isTopicClosedForReply && (isGuest || userHasPermissionToReply);
      var hideRepliesHeader = !hasReplies && !isGuest && !userHasPermissionToReply;
      var showStickyComposer = this.showStickyComposerForState(this.state);
      var editorSharedProps = {
        replyId: null,
        parentReplyId: null,
        placeholder: (_this$props$phrases$F = (_this$props$phrases = this.props.phrases) === null || _this$props$phrases === void 0 ? void 0 : (_this$props$phrases$F2 = _this$props$phrases.Forum) === null || _this$props$phrases$F2 === void 0 ? void 0 : _this$props$phrases$F2['threaded.replies.editor.placeholder']) !== null && _this$props$phrases$F !== void 0 ? _this$props$phrases$F : '',
        parentTopicId: Number(topic.id),
        contentType: topic.contentType,
        disableFileAttachments: disableFileAttachments,
        currentUser: currentUser,
        redirect: true
      };
      return (0, _preact.h)(_HubAI.OnDemandTranslationProvider, {
        initialContent: initialContent,
        languageList: languageList,
        shouldTranslateOnlyOneReply: false,
        threadedRepliesEnabled: showThreadedReplies
      }, (0, _preact.h)("div", {
        className: "box__content"
      }, showThreadedReplies ? (0, _preact.h)(_Topic2.default, {
        topic: topic,
        authors: authors,
        currentUser: currentUser,
        userSubscribed: userSubscribed,
        topicBodyProps: topicContent,
        unlimitedEditPermission: unlimitedEditPermission,
        disableFileAttachments: disableFileAttachments,
        attachmentCdn: attachmentCdn,
        userHasPermissionToReply: userHasPermissionToReply && !isTopicClosedForReply,
        onReplyClick: !isTopicClosedForReply ? function () {
          return _this3.handleEditorFocus();
        } : undefined,
        showPostActions: showPostActions,
        totalReplyCount: totalReplies,
        bestAnswer: bestAnswer,
        pinnedReply: pinnedReply
      }) : (0, _preact.h)("div", {
        className: "box qa-topic-first-post",
        "data-helper": "class-toggle"
      }, (0, _preact.h)(_Topic.default, (0, _extends2.default)({
        topic: topic,
        currentPage: currentPage,
        attachmentCdn: attachmentCdn,
        authors: authors,
        unlimitedEditPermission: unlimitedEditPermission,
        currentUser: currentUser,
        disableFileAttachments: disableFileAttachments,
        contentHelpfulnessData: contentHelpfulnessData,
        pinnedReply: pinnedReply,
        showPostActions: showPostActions,
        bestAnswer: bestAnswer,
        onEditorClick: function onEditorClick() {
          return _this3.handleEditorFocus();
        },
        userSubscribed: userSubscribed,
        totalReplyCount: totalReplies,
        showReplyEditor: showThreadedReplies && userHasPermissionToReply
      }, topicContent))), isTopicClosedForReply && (0, _preact.h)(_TopicClosed.default, {
        message: (0, _preact.h)(_phrase.default, {
          p: "topic.closed.info_message",
          m: "Forum"
        })
      }), showHasNoPermission && (0, _preact.h)(_TopicClosed.default, {
        message: (0, _preact.h)(_phrase.default, {
          p: "topic.closed.no_permission",
          m: "Forum"
        })
      }), showThreadedReplies && !_common.common.isModuleActive('highlightedBestAnswer') && (0, _preact.h)("div", {
        className: "box__content"
      }, (0, _preact.h)(_PinnedAndBestAnswerSection.default, {
        authors: authors,
        bestAnswer: bestAnswer,
        pinnedReply: pinnedReply
      })), showThreadedReplies && !isTopicClosedForReply && (isGuest || userHasPermissionToReply) && (0, _preact.h)("div", {
        ref: this.inlineEditorWrapperRef,
        className: (0, _classnames.default)('box', 'editor', 'topic-reply-composer-inline')
      }, (0, _preact.h)(_Editor.Editor, (0, _extends2.default)({}, editorSharedProps, {
        editorRootId: "reply-editor-inline",
        isOpen: isEditorOpen,
        onFocus: function onFocus() {
          return _this3.handleEditorFocus();
        },
        onCancel: function onCancel() {
          return _this3.handleEditorCancel();
        },
        onDraftChange: function onDraftChange(hasDraft) {
          return _this3.setState(function (prev) {
            var collapse = !hasDraft && !prev.inlineEditorInView && prev.isEditorOpen;
            return {
              inlineHasDraft: hasDraft,
              isEditorOpen: collapse ? false : prev.isEditorOpen
            };
          });
        },
        onFocusScopeChange: function onFocusScopeChange(within) {
          return _this3.setState(function (prev) {
            var collapse = !within && !prev.inlineEditorInView && prev.isEditorOpen;
            return {
              inlineFocusWithin: within,
              isEditorOpen: collapse ? false : prev.isEditorOpen
            };
          });
        }
      }))), shouldDisplayReplies && (0, _preact.h)("div", {
        className: (0, _classnames.default)({
          box: !showThreadedReplies,
          'topic-replies--no-reply': !hasReplies,
          'topic-replies--hidden': hideRepliesHeader
        })
      }, showThreadedReplies ? (0, _preact.h)(_ThreadedRepliesWrapper.default, {
        type: topic.contentType,
        totalReplies: totalReplies,
        currentSort: currentSort,
        replies: replies,
        authors: authors,
        currentUser: currentUser,
        topic: topic,
        pageSize: 10,
        enableSEOUrls: true,
        canMarkBestAnswer: canMarkBestAnswer,
        attachmentCdn: attachmentCdn,
        unlimitedEditPermission: unlimitedEditPermission,
        disableFileAttachments: disableFileAttachments,
        userHasPermissionToReply: userHasPermissionToReply && !isTopicClosedForReply,
        showPostActions: showPostActions,
        onRepliesUpdated: function onRepliesUpdated(replies) {
          return _this3.handleRepliesUpdated(replies);
        }
      }) : (0, _preact.h)(_Replies.default, (0, _extends2.default)({
        topic: topic,
        currentRepliesPage: currentPage,
        attachmentCdn: attachmentCdn,
        authors: authors,
        bestAnswer: bestAnswer,
        unlimitedEditPermission: unlimitedEditPermission,
        currentUser: currentUser,
        disableFileAttachments: disableFileAttachments,
        showFirstToReplyBanner: showFirstToReplyBanner,
        showPostActions: showPostActions
      }, repliesProps))), showStickyComposer && (0, _preact.h)("div", {
        className: "topic-reply-composer-sticky-dock"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('box', 'editor', 'topic-reply-composer-sticky-dock__editor')
      }, (0, _preact.h)(_Editor.Editor, (0, _extends2.default)({}, editorSharedProps, {
        editorRootId: "reply-editor-sticky",
        isOpen: isStickyEditorOpen,
        onFocus: function onFocus() {
          return _this3.handleStickyEditorFocus();
        },
        onCancel: function onCancel() {
          return _this3.handleStickyEditorCancel();
        },
        onDraftChange: function onDraftChange(hasDraft) {
          return _this3.setState({
            stickyHasDraft: hasDraft
          });
        },
        onFocusScopeChange: function onFocusScopeChange(within) {
          return _this3.setState({
            stickyFocusWithin: within
          });
        }
      }))))));
    }
  }]);
  return TopicPage;
}(_preact.Component);

var _default = (0, _HubAI.withOnDemandTranslationProps)(TopicPage, ['translatedBestAnswerText', 'translatedPinnedReplyText']);

exports.default = _default;
var cssAnchorName = 'topic-view';
exports.cssAnchorName = cssAnchorName;